import React from 'react'
import Layout from '../Layout'
import ReactHtmlParser from 'react-html-parser'
export default function Careers(props) {
    return (
        <Layout props={props}>
            <div className="px-5 py-4 stctPgWrpr">
                <span>{ReactHtmlParser(global.storeDetails.careers)}</span>
            </div>
        </Layout>
    )
}
